import icon from '@material-ui/icons/Person'

export default { icon }
